module.exports = __webpack_public_path__ + "static/assets/4f4fcda5c557615e6c169920d91ccad7.png";